exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[v-cloak] {\n  display: none;\n}\ndiv.file-listing {\n  width: 220px;\n  margin: auto;\n  padding: 10px;\n  border-bottom: 1px solid #ddd;\n}\ndiv.file-listing img {\n  height: 200px;\n}\n.custom-border-red {\n  border-color: #dc3545 !important;\n}\n", ""]);

// exports
